import HandleAxiosError from 'utils/helpers/HandleAxiosError'
import ApiClient from 'utils/plugins/ApiClient'

export const userProfile = (payload) =>
  ApiClient.get('/user/profile', payload)
    .then((respose) => respose.data.response.data)
    .catch((error) => {
      throw HandleAxiosError(error)
    })
